import BusinessUnitCompany from 'data/BusinessUnitCompany';
import SalesOrderConfig from 'data/SalesOrderConfig';
import { get, put } from 'lib/API';

export const getBusinessUnitCompanyInfo = async (
  [businessUnitId, companyId]: any[],
  { token }: any
): Promise<any> => {
  const businessUnitCompanyInfo = await get(`v1/businessUnitCompany/${businessUnitId}/${companyId}`, token);

  if (businessUnitCompanyInfo && businessUnitCompanyInfo.creditId) {
    try {
      const credit = await get(`v1/credit/${businessUnitCompanyInfo.creditId}`, token);
      businessUnitCompanyInfo.credit = credit;
    } catch (error) {
      console.error('Error fetching credit details:', error);
      businessUnitCompanyInfo.credit = null;
    }
  }

  return businessUnitCompanyInfo;
};

export const getBusinessUnitsForCompany = async (
  [companyId]: any[],
  { token }: any
): Promise<BusinessUnitCompany[]> => {
  return await get(`v1/businessUnitCompany/company/${companyId}`, token);
};

export const validateBusinessUnitCompany = async (
  [businessUnitId, companyId, businessUnitCompanyId]: any[],
  { token }: any
): Promise<any> => {
  return await get(`v1/businessUnitCompany/${businessUnitCompanyId}?businessUnitId=${businessUnitId}&companyId=${companyId}`, token);
};

export const saveCompanySalesOrderConfig = async (salesOrderConfig: SalesOrderConfig, token: any, businessUnitId: number | undefined, companyId: string): Promise<any> => {
  return await put(`v1/businessUnitCompany/salesOrderConfig/${companyId}/${businessUnitId}`, token, salesOrderConfig);
};

export const getCompanySalesOrderConfig = async ([businessUnitId, companyId]: any[], { token }: any): Promise<any> => {
  return await get(`v1/businessUnitCompany/salesOrderConfig/${companyId}/${businessUnitId}`, token);
};
